import * as React from 'react';
import { Provider } from "mobx-react";
import { createRoot } from 'react-dom/client';

import BtsIndex from './pages/BtsIndex';
import BlockKitStore from './stores/BlockKitStore';
import StudioUserStore from './stores/StudioUserStore';
import SalesStatisticsStore from './stores/SalesStatisticsStore';
import { Route, BrowserRouter as Router, Routes } from "react-router-dom";
import 'bootstrap/dist/css/bootstrap.min.css';
import './styles/global.css';
import '../shared/internationalization/I18nSetting';

declare const module: any;

const blockKitStore = new BlockKitStore();
const studioUserStore = new StudioUserStore();
const salesStatisticsStore = new SalesStatisticsStore();

document.body.style.overflow = "hidden";

const container = document.getElementById('boot');
const root = createRoot(container!);

root.render(
  <Provider blockKitStore={blockKitStore} studioUserStore={studioUserStore} salesStatisticsStore={salesStatisticsStore}>
    <Router>
      <Routes>
        <Route path="/*" element={<BtsIndex />}/>
      </Routes>
    </Router>
  </Provider>
);

if (module.hot) {
  module.hot.accept();
}

